import React from 'react';
import { ArrowRight, Scale, ClipboardCheck, Truck } from 'lucide-react';
export function TopicNav() {
  const topics = [{
    id: 'Federal-Regulations',
    title: 'Federal Regulations',
    desc: 'Overview of the FMCSR and Title 49.',
    Icon: Scale,
    link: '#Federal-Regulations',
    number: '01'
  }, {
    id: 'Driver-Qualifications',
    title: 'Driver Qualifications',
    desc: 'Rules for age, licensing, logs, and hours of service.',
    Icon: ClipboardCheck,
    link: '#Driver-Qualifications',
    number: '02'
  }, {
    id: 'Cargo-Transportation',
    title: 'Cargo Transportation',
    desc: 'Part 393 cargo securement and safety rules.',
    Icon: Truck,
    link: '#Cargo-Transportation',
    number: '03'
  }];
  return <section className="py-16 bg-legal-light border-b border-legal-border" data-id="element-204">
      <div className="max-w-legal-container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-205">
        <div className="text-center mb-12" data-id="element-206">
          <h2 className="text-3xl font-bold text-legal-dark" data-id="element-207">
            Navigate Legal Resources
          </h2>
          <p className="mt-4 text-lg text-legal-gray max-w-2xl mx-auto" data-id="element-208">
            Quickly find the specific federal trucking regulations relevant to
            your commercial vehicle accident case.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-209">
          {topics.map(topic => {
          const Icon = topic.Icon;
          return <a key={topic.id} href={topic.link} className="group bg-white rounded-lg shadow-sm border border-legal-border overflow-hidden hover:shadow-md hover:border-legal-red transition-all duration-300 transform hover:-translate-y-1 flex flex-col h-full" data-id="element-210">
                <div className="relative bg-legal-dark p-12 flex items-center justify-center" data-id="element-211">
                  <span className="absolute top-4 left-4 bg-white/10 backdrop-blur-sm px-2.5 py-1 rounded text-xs font-bold text-white border border-white/20" data-id="element-212">
                    {topic.number}
                  </span>
                  <div className="w-32 h-32 bg-legal-red/10 rounded-full flex items-center justify-center group-hover:bg-legal-red/20 transition-colors" data-id="element-213">
                    <Icon className="w-20 h-20 text-legal-red" strokeWidth={1.75} data-id="element-214" />
                  </div>
                </div>
                <div className="p-6 flex-grow flex flex-col" data-id="element-215">
                  <h3 className="text-xl font-bold text-legal-dark mb-2 group-hover:text-legal-red transition-colors" data-id="element-216">
                    {topic.title}
                  </h3>
                  <p className="text-legal-gray mb-6 flex-grow" data-id="element-217">{topic.desc}</p>
                  <div className="flex items-center text-legal-red font-semibold text-sm mt-auto" data-id="element-218">
                    Read Section{' '}
                    <ArrowRight className="w-4 h-4 ml-1 group-hover:translate-x-1 transition-transform" data-id="element-219" />
                  </div>
                </div>
              </a>;
        })}
        </div>
      </div>
    </section>;
}